var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stories-archive-view',{attrs:{"loading":_vm.loading,"stories":_vm.stories,"selected-sort":_vm.selectedSort,"enable-scroll":_vm.enableScrollStories},on:{"onSort":_vm.handleSort,"cardClick":_vm.handleStoryClick,"next":_vm.getNextPage}})}
var staticRenderFns = []

export { render, staticRenderFns }